{
  "collapse": "Dölj",
  "expand": "Expandera"
}
